import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import {
  blueColour,
  defaultFontItalic,
  defaultFontNormal,
} from "../utils/styling";

export const getIndentificationOfWorldwideGroupParagraphs = (data) => {
  const { groupName, ultimateParentName } = data;

  const paragraphs = [
    {
      segments: [
        {
          text: "Before the CIR calculations can be undertaken it is necessary to identify the ",
          font: defaultFontNormal,
        },
        {
          text: "worldwide group",
          font: defaultFontItalic,
        },
        {
          text: " and its ",
          font: defaultFontNormal,
        },
        {
          text: "ultimate parent.",
          font: defaultFontItalic,
        },
      ],
    },
    {
      segments: [
        {
          text: "The provisions are complicated and include a number of specific provisions that need to be considered (for example in relation to stapled entities and for business combinations), however they are based on the equivalent definitions under International Accounting Standards (IAS). As such, in determining the ultimate parent and group members for groups drawing up accounts under other accounting standards, it is necessary to consider whether the consolidation would be different under IAS.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The ultimate parent must be a company or an entity listed on a recognised stock exchange and sufficiently widely held. It cannot be a consolidated subsidiary of another relevant entity. Certain government, Crown and foreign sovereign power entities are also excluded.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The members of the worldwide group are the subsidiaries of the ultimate parent that would be consolidated if the ultimate parent was to draw up accounts under International Accounting Standards. This excludes subsidiaries:",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: "Held at fair value (rather than consolidated on a line-by-line basis); or",
          font: defaultFontNormal,
        },
      ],
    },
    {
      bullet: "dot",
      segments: [
        {
          text: 'For periods of account beginning on or after 1 January 2018 but before 1 April 2023, that are accounted for on a "held for sale" or “held for distribution to owners” basis',
          font: defaultFontNormal,
        },
      ],
    },
    {
      segments: [
        {
          text: "Application to the ",
          font: defaultFontItalic,
          break: 1,
        },
        {
          text: `[${groupName}]`,
          font: defaultFontItalic,
        },
        {
          text: " group",
          font: defaultFontItalic,
        },
      ],
    },
    {
      segments: [
        {
          text: "[Relationship team to insert short summary of the work undertaken] / [You have informed us that you are comfortable that ",
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: `[${ultimateParentName}]`,
          font: defaultFontNormal,
          color: blueColour,
        },
        {
          text: " is the ultimate parent of the worldwide group and that no UK Group Companies are missing from the calculations. We have relied on the information provided by you in undertaking our work and have not undertaken any work to verify this conclusion. Please let us know if you would like us to consider it further.]",
          font: defaultFontNormal,
          color: blueColour,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Identification of worldwide group"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
